<template>
  <section class="container">
    <div class="order">
      <div class="order__container">
        <!-- 訂單資訊 -->
        <div class="order__card">
          <div class="order__header">
            <i class="el-icon-document"></i>
            <h2>{{ $t('order.orderInfo') }}</h2>
          </div>
          <div class="order__body">
            <div class="order__section">
              <div class="order__info-grid">
                <div class="order__info-item">
                  <span class="order__label">{{ $t('orders.column.orderNumber') }}</span>
                  <span class="order__value">{{ OrderData.orderCode }}</span>
                </div>
                <div class="order__info-item">
                  <span class="order__label">{{ $t('orders.column.status') }}</span>
                  <span class="order__value">{{ OrderData.statusName }}</span>
                </div>
                <div class="order__info-item">
                  <span class="order__label">{{ $t('order.salesAmount') }}</span>
                  <span class="order__value">{{ OrderData.orderAmountPrice | toCurrency }}</span>
                </div>
                <div class="order__info-item">
                  <span class="order__label">{{ $t('order.orderDate') }}</span>
                  <span class="order__value">{{ OrderData.orderDate | toTaipei | moment('YYYY-MM-DD HH:mm:ss') }}</span>
                </div>
                <div class="order__info-item">
                  <span class="order__label">{{ $t('order.paymentAmount') }}</span>
                  <span class="order__value">{{ OrderData.orderActualPrice | toCurrency }}</span>
                </div>
                <div class="order__info-item">
                  <span class="order__label">{{ $t('order.discount') }}</span>
                  <span class="order__value">{{ (OrderData.orderAmountPrice - OrderData.orderActualPrice) | toCurrency }}</span>
                </div>
              </div>
            </div>

            <div class="order__section">
              <div class="order__info-grid">
                <div class="order__info-item">
                  <span class="order__label">{{ $t('orders.column.paymentMethod') }}</span>
                  <span class="order__value">{{ OrderData.orderPayModeName }}</span>
                </div>
                <div class="order__info-item">
                  <span class="order__label">{{ $t('order.paymentDate') }}</span>
                  <span class="order__value">{{ OrderData.orderPayDate | toTaipei | moment('YYYY-MM-DD HH:mm:ss') }}</span>
                </div>
                <div v-if="OrderData.orderPayMode == 2" class="order__info-item">
                  <span class="order__label">{{ $t('shopping.label.paymentCode') }}</span>
                  <span class="order__value">{{ OrderData.ecPayPaymentNo }}</span>
                </div>
                <div v-if="OrderData.orderPayMode == 6" class="order__info-item">
                  <span class="order__label">{{ $t('shopping.label.bankCode') }}</span>
                  <span class="order__value">{{ OrderData.ecPayBankCode }}</span>
                </div>
                <div v-if="OrderData.orderPayMode == 6" class="order__info-item">
                  <span class="order__label">{{ $t('shopping.label.virtualAccount') }}</span>
                  <span class="order__value">{{ OrderData.ecPayvAccount }}</span>
                </div>
                <div v-if="OrderData.orderPayMode == 2 || OrderData.orderPayMode == 6" class="order__info-item">
                  <span class="order__label">{{ $t('shopping.label.paymentDeadline') }}</span>
                  <span class="order__value">{{ OrderData.ecPayExpireDate | toTaipei | moment('YYYY-MM-DD HH:mm:ss') }}</span>
                </div>
                <div v-if="OrderData.orderPayMode == 3" class="order__info-item">
                  <span class="order__label">{{ $t('order.label.accountLast5') }}</span>
                  <span class="order__value">{{ OrderData.ecPayWebAtmaccNo }}</span>
                </div>
                <div v-if="OrderData.orderPayMode == 5" class="order__info-item">
                  <span class="order__label">{{ $t('order.label.installment') }}</span>
                  <span class="order__value">{{ OrderData.ecPayStage }}</span>
                </div>
              </div>
            </div>

            <div class="order__section order__section--last">
              <div class="order__info-grid">
                <div class="order__info-item">
                  <span class="order__label">{{ $t('shopping.label.invoice') }}</span>
                  <span class="order__value">{{ OrderData.orderInvoiceTypeName }}</span>
                </div>
                <template v-if="OrderData.orderInvoiceType === 2">
                  <div class="order__info-item">
                    <span class="order__label">{{ $t('shopping.label.mobileCarrier') }}</span>
                    <span class="order__value">{{ OrderData.memberInvoiceCode }}</span>
                  </div>
                </template>
                <template v-if="OrderData.orderInvoiceType === 3">
                  <div class="order__info-item">
                    <span class="order__label">{{ $t('shopping.label.invoiceTitle') }}</span>
                    <span class="order__value">{{ OrderData.memberInvoiceTitle }}</span>
                  </div>
                  <div class="order__info-item">
                    <span class="order__label">{{ $t('shopping.label.taxId') }}</span>
                    <span class="order__value">{{ OrderData.memberInvoiceTaxId }}</span>
                  </div>
                  <div class="order__info-item order__info-item--full">
                    <span class="order__label">{{ $t('order.label.invoiceAddress') }}</span>
                    <span class="order__value">
                      {{ OrderData.memberInvoiceZipCode }}
                      {{ OrderData.memberInvoiceCounty }}
                      {{ OrderData.memberInvoiceCity }}
                      {{ OrderData.memberInvoiceAddress }}
                    </span>
                  </div>
                  <div class="order__info-item">
                    <span class="order__label">{{ $t('order.label.invoicePhone') }}</span>
                    <span class="order__value">{{ OrderData.memberInvoicePhone }}</span>
                  </div>
                  <div class="order__info-item">
                    <span class="order__label">{{ $t('order.label.invoiceEmail') }}</span>
                    <span class="order__value">{{ OrderData.memberInvoiceEmail }}</span>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>

        <!-- 收件人資訊 -->
        <div class="order__card">
          <div class="order__header">
            <i class="el-icon-user"></i>
            <h2>{{ $t('shopping.section.recipientInfo') }}</h2>
          </div>
          <div class="order__body">
            <div class="order__info-grid">
              <div class="order__info-item">
                <span class="order__label">{{ $t('shopping.label.recipientName') }}</span>
                <span class="order__value">{{ OrderData.orderName }}</span>
              </div>
              <div class="order__info-item">
                <span class="order__label">{{ $t('shopping.label.recipientPhone') }}</span>
                <span class="order__value">{{ OrderData.orderPhone }}</span>
              </div>
              <div class="order__info-item order__info-item--full">
                <span class="order__label">{{ $t('shopping.label.recipientAddress') }}</span>
                <span class="order__value">
                  {{ OrderData.orderZipCode }} {{ OrderData.orderCounty }}
                  {{ OrderData.orderCity }} {{ OrderData.orderAddress }}
                </span>
              </div>
              <div v-if="OrderData.orderNote" class="order__info-item order__info-item--full">
                <span class="order__label">{{ $t('shopping.label.shippingNotes') }}</span>
                <span class="order__value">{{ OrderData.orderNote }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 訂單課程資訊 -->
        <div class="order__card">
          <div class="order__header">
            <i class="el-icon-tickets"></i>
            <h2>{{ $t('order.courseInfo') }}</h2>
          </div>
          <div class="order__body">
            <div class="order__course-table">
              <div class="order__course-header">
                <div class="order__course-cell order__course-cell--name">{{ $t('order.label.courseName') }}</div>
                <div class="order__course-cell">{{ $t('order.label.originalPrice') }}</div>
                <div class="order__course-cell">{{ $t('order.label.discountedPrice') }}</div>
                <div class="order__course-cell">{{ $t('order.label.startDate') }}</div>
                <div class="order__course-cell">{{ $t('order.label.endDate') }}</div>
              </div>
              <div
                v-for="(item, index) in OrderData.ordersDetails"
                :key="index"
                class="order__course-row"
              >
                <div class="order__course-cell order__course-cell--name" data-label="課程名稱">
                  <span class="order__course-name">{{ item.courseName }}</span>
                  <el-button
                    v-if="item.courseType === 2"
                    type="primary"
                    size="mini"
                    icon="el-icon-document"
                    @click="GetOrderCourseOptional(item)"
                  >
                    {{ $t('order.button.viewTeachers') }}
                  </el-button>
                </div>
                <div class="order__course-cell" :data-label="$t('order.label.originalPrice')">
                  {{ item.coursePrice | toCurrency }}
                </div>
                <div class="order__course-cell" :data-label="$t('order.label.discountedPrice')">
                  {{ item.courseActualPrice | toCurrency }}
                </div>
                <div class="order__course-cell" :data-label="$t('order.label.startDate')">
                  {{ item.courseViewStartDate | toTaipei | moment('YYYY-MM-DD') }}
                </div>
                <div class="order__course-cell order__course-cell--end" :data-label="$t('order.label.endDate')">
                  {{ item.courseViewEndDate | toTaipei | moment('YYYY-MM-DD') }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 返回按鈕 -->
        <div class="order__actions">
          <router-link to="/member/orders" class="order__back-link">
            <i class="el-icon-back"></i>
            {{ $t('common.button.backToList') }}
          </router-link>
        </div>
      </div>

      <!-- 教師資訊對話框 -->
      <el-dialog
        :title="optionalChoose.title"
        :visible.sync="teacherDialogVisible"
        width="800px"
        custom-class="order__dialog"
      >
        <div class="order__teacher-table">
          <div class="order__teacher-header">
            <div class="order__teacher-cell">{{ $t('course.label.subject') }}</div>
            <div class="order__teacher-cell">{{ $t('order.label.selectedTeacher') }}</div>
          </div>
          <div
            v-for="(item, index) in optionalChoose.list"
            :key="index"
            class="order__teacher-row"
          >
            <div class="order__teacher-cell" data-label="科目">{{ item.subjectName }}</div>
            <div class="order__teacher-cell" data-label="教師">{{ item.teachers }}</div>
          </div>
        </div>
      </el-dialog>
    </div>
  </section>
</template>

<script>
import { GetOrderById, GetOrderCourseOptional } from '@/api/OrderApi';
import { GetCityByZipCode } from '@/lib/zipcode';

export default {
  data() {
    // 建立你的初始化 model data
    return {
      teacherDialogVisible: false, // 教師對話框可見性
      tempOptionalChoose: {},
      optionalChoose: {
        title: '',
        list: [],
      },
      OrderData: {
        orderId: 0,
        orderCode: '',
        statusName: '',
        orderPayModeName: '',
        orderAmountPrice: 0,
        orderActualPrice: 0,
        orderDate: '',
        payStatusName: '',
        discountPrice: null,
        memberId: 0,
        orderAddress: '',
        orderName: '',
        orderNote: '',
        orderPayDate: '',
        orderPayMode: 0,
        orderPhone: '',
        ordersDetails: [],
        status: 1,
      },
    };
  },
  created() {
    this.GetData();
  },
  methods: {
    GetData() {
      // 取得 url id 的方法
      const { id } = this.$route.params;
      GetOrderById({ Id: id }).then((response) => {
        if (response.data.statusCode === 0) {
          this.OrderData = response.data.data;
          if (this.OrderData.orderCity === null || this.OrderData.orderCity === '') {
            this.OrderData.orderCity = GetCityByZipCode(this.OrderData.orderZipCode);
          }
          this.$emit('update:currentPage', {
            name: '',
            title: this.OrderData.orderCode,
            path: '',
          });
        }
      });
    },
    GetOrderCourseOptional(date) {
      this.optionalChoose.title = '';
      this.optionalChoose.list = [];
      const { id } = this.$route.params;
      const postData = {
        OrderId: id,
        CourseId: date.courseId,
      };
      if (this.tempOptionalChoose[date.courseId]) {
        this.optionalChoose.title = date.courseName;
        this.optionalChoose.list = [...this.tempOptionalChoose[date.courseId]];
        this.teacherDialogVisible = true;
        return '';
      }
      return GetOrderCourseOptional(postData).then((res) => {
        if (res.data.statusCode === 0) {
          const newData = this._.chain(res.data.data)
            .groupBy('subjectId')
            .map((value) => (
              {
                subjectId: value[0].subjectId,
                subjectName: value[0].subjectName,
                teachers: this._.join(value.map((item) => item.teacherName), '，'),
              })).value();
          this.$set(this.tempOptionalChoose, date.courseId, newData);
          this.optionalChoose.title = date.courseName;
          this.optionalChoose.list = [...newData];
          this.teacherDialogVisible = true;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/_variables.scss';

.order {
  &__card {
    background-color: var(--background-white);
    border-radius: var(--border-radius-lg);
    border: 1px solid var(--border-light);
    box-shadow: var(--shadow-sm);
    margin-bottom: 24px;
    overflow: hidden;
  }

  &__header {
    background-color: var(--background-light);
    padding: 12px 32px;
    border-bottom: 1px solid var(--border-light);
    display: flex;
    align-items: center;
    gap: 12px;

    @media (max-width: $breakpoint-sm) {
      padding: 12px 20px;
    }

    i {
      font-size: 24px;
      color: var(--primary-color);
    }

    h2 {
      margin: 0;
      font-size: var(--font-size-lg);
      font-weight: 600;
      color: var(--text-primary);

      @media (max-width: $breakpoint-sm) {
        font-size: var(--font-size-base);
      }
    }
  }

  &__body {
    padding: 28px;

    @media (max-width: $breakpoint-sm) {
      padding: 20px;
    }
  }

  &__section {
    padding-bottom: 12px;
    margin-bottom: 12px;
    border-bottom: 1px solid var(--border-lighter);

    &--last {
      border-bottom: none;
      margin-bottom: 0;
      padding-bottom: 0;
    }
  }

  &__info-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px 16px;

    @media (max-width: $breakpoint-md) {
      grid-template-columns: 1fr;
      gap: 16px;
    }
  }

  &__info-item {
    display: flex;
    flex-direction: column;
    gap: 8px;

    &--full {
      grid-column: 1 / -1;
    }

    &--highlight {
      background-color: var(--primary-light-color);
      padding: 16px;
      border-radius: var(--border-radius-base);
    }
  }

  &__label {
    font-size: var(--font-size-sm);
    color: var(--text-secondary);
    font-weight: 500;
  }

  &__value {
    font-family: var(--font-family);
    font-size: var(--font-size-base);
    color: var(--text-primary);
    word-break: break-word;

    &--price {
      font-size: var(--font-size-lg);
      font-weight: 700;
      color: var(--primary-color);
    }
  }

  &__course-table {
    border: 1px solid var(--border-light);
    border-radius: var(--border-radius-base);
    overflow: hidden;
  }

  &__course-header {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr 1fr 1fr;
    background-color: var(--background-base);
    font-weight: 600;
    font-size: var(--font-size-sm);
    color: var(--text-primary);

    @media (max-width: $breakpoint-md) {
      display: none;
    }
  }

  &__course-row {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr 1fr 1fr;
    border-top: 1px solid var(--border-lighter);
    transition: background-color var(--transition-fast);

    &:first-child {
      border-top: none;
    }

    &:hover {
      background-color: var(--primary-light-color);
    }

    @media (max-width: $breakpoint-md) {
      grid-template-columns: 1fr;
      padding: 20px;
    }
  }

  &__course-cell {
    padding: 16px;
    display: flex;
    align-items: center;
    border-right: 1px solid var(--border-lighter);

    &:last-child {
      border-right: none;
    }

    &--name {
      flex-direction: column;
      align-items: flex-start;
      gap: 12px;
    }

    &--end {
      color: #f56c6c;
      font-weight: 500;
    }

    @media (max-width: $breakpoint-md) {
      border-right: none;
      padding: 8px 0;

      &::before {
        content: attr(data-label);
        font-size: var(--font-size-sm);
        color: var(--text-secondary);
        margin-right: 8px;
        min-width: 80px;
      }

      &--name::before {
        display: none;
      }
    }
  }

  &__course-name {
    font-weight: 500;
    color: var(--text-primary);
  }

  &__actions {
    display: flex;
    justify-content: flex-end;
    margin-top: 32px;
  }

  &__back-link {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 12px 24px;
    color: var(--text-regular);
    text-decoration: none;
    border: 1px solid var(--border-base);
    border-radius: var(--border-radius-base);
    background-color: var(--background-white);
    transition: all var(--transition-fast);
    font-size: var(--font-size-sm);

    &:hover {
      color: var(--primary-color);
      border-color: var(--primary-color);
      background-color: var(--primary-light-color);
    }

    i {
      font-size: 16px;
    }
  }

  &__teacher-table {
    border: 1px solid var(--border-light);
    border-radius: var(--border-radius-base);
    overflow: hidden;
  }

  &__teacher-header {
    display: grid;
    grid-template-columns: 1fr 2fr;
    background-color: var(--background-base);
    font-weight: 600;
    font-size: var(--font-size-sm);
    color: var(--text-primary);

    @media (max-width: $breakpoint-sm) {
      display: none;
    }
  }

  &__teacher-row {
    display: grid;
    grid-template-columns: 1fr 2fr;
    border-top: 1px solid var(--border-lighter);

    &:first-child {
      border-top: none;
    }

    @media (max-width: $breakpoint-sm) {
      grid-template-columns: 1fr;
      padding: 16px;
    }
  }

  &__teacher-cell {
    padding: 16px;
    display: flex;
    align-items: center;
    border-right: 1px solid var(--border-lighter);

    &:last-child {
      border-right: none;
    }

    @media (max-width: $breakpoint-sm) {
      border-right: none;
      padding: 8px 0;

      &::before {
        content: attr(data-label) ": ";
        font-size: var(--font-size-sm);
        color: var(--text-secondary);
        margin-right: 8px;
        font-weight: 600;
      }
    }
  }
}

/deep/ .order__dialog {
  border-radius: var(--border-radius-lg);

  .el-dialog__header {
    background-color: var(--background-light);
    padding: 20px 24px;
    border-bottom: 1px solid var(--border-light);
  }

  .el-dialog__title {
    font-size: var(--font-size-lg);
    font-weight: 600;
    color: var(--text-primary);
  }

  .el-dialog__body {
    padding: 24px;
  }
}
</style>
